import React, { useState, useEffect } from "react";
import Navbar2 from "../Components/Navbar2";
import Footer2 from "../Components/Footer2";
import Aos from "aos";
import Loader from "../Loader/Loader.jsx";
import { getWorkWithGisul } from "../Common/apis";

function OurWork() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true
    });

    async function fetchJobs() {
      try {
        const res = await getWorkWithGisul();
        setJobs(res?.data || []); // Adjust if your API structure is different
      } catch (error) {
        console.error("Failed to fetch jobs", error);
      } finally {
        setLoading(false);
      }
    }

    fetchJobs();
  }, []);

  if (loading) return <Loader />;
  return (
    <>
      <div className="new-home overflow-hidden">
        <Navbar2 />
        <div className="flex justify-between xl:gap-[36px] gap-[20px] lg:flex-row flex-col items-start w-full xxl:pr-[60px] xl:pr-[60px] lg:pr-[20px] pr-[20px] lg:pl-0 pl-[20px] lg:pb-[205px]">
          <div className="relative lg:mt-[84px] mt-[50px] lg:w-auto w-full">
            <div className="md:flex hidden flex-col pb-[24px] gap-[12px] ml-[-70px] items-start">
              <img
                data-aos="flip-up"
                src="/assets/media/item3.svg"
                className="xl:h-auto lg:h-[53px] md:h-[53px] h-[53px]"
                alt=""
              />
              <img
                data-aos="flip-up"
                src="/assets/media/item4.svg"
                className="xl:h-auto lg:h-[53px] md:h-[53px] h-[53px]"
                alt=""
              />
            </div>
            <div className="flex md:hidden flex-col lg:pb-[45px] pb-[16px] gap-[8px] ml-[-65px] items-start">
              <img
                data-aos="flip-up"
                src="/assets/media/item3.svg"
                className="h-[53px]"
                alt=""
              />
              <img
                data-aos="flip-up"
                src="/assets/media/item4.svg"
                className="h-[53px]"
                alt=""
              />
            </div>
            <div className="lg:pl-[44px] pl-0 lg:pt-[90px] pt-[30px] md:flex hidden justify-center">
              <img src="/assets/media/vector2.svg" alt="" />
            </div>
          </div>
          <div className="xl:max-w-[724px] max-w-[800px] w-full lg:mt-[90px] mt-[40px]">
            <div className="relative flex items-center flex-col">
              <button className="font-[500] relative z-10 font-sans bg-[#FDD60D] py-[17px] px-[23px] rounded-full text-[40px] leading-[46px]">
                Open Position
              </button>
              {jobs?.length === 1 ? (
                <div className="job-lines"></div>
              ) : (
                <div className="lines"></div>
              )}

              <div className="grid md:grid-cols-2 relative z-20 grid-cols-1 gap-x-[24px] gap-y-[28px] md:pt-[62px] pt-[40px]">
                {jobs.map((job, index) => (
                  <div
                    key={job._id}
                    className="bg-[#FFFFFF] rounded-[20px] border border-[#6953A3] py-[22px] px-[16px]"
                  >
                    <div className="flex gap-[15px] pb-[22px]">
                      <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                        {job.jobType}
                      </button>
                      <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                        {job.jobLocation}
                      </button>
                      <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                        ${job.salary}
                      </button>
                    </div>
                    <h6 className="font-[700] font-sans text-[22px] text-[#263238] pb-[6px]">
                      {job.title}
                    </h6>
                    <p className="font-[400] font-sans capitalize text-[14px] text-[#263238] pb-[20px]">
                      {job.description.replace(/<[^>]+>/g, "")}
                    </p>
                    <div className="flex justify-between items-center">
                      <button className="py-[14px] px-[26px] text-[#263238] rounded-[5px] bg-[#F1E60D] font-sans font-[400] text-[14px]">
                        Apply
                      </button>
                      <div className="flex items-center gap-[4px]">
                        <img src="/assets/media/people.svg" alt="people" />
                        <p className="font-[400] text-[14px] text-[#263238]">
                          24 Applied
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
                {jobs.length === 0 && (
                  <p className="text-[#263238] text-center col-span-2">
                    No open positions found.
                  </p>
                )}
                {/* <div className="bg-[#FFFFFF] rounded-[20px] border border-[#6953A3] py-[22px] px-[16px]">
                  <div className="flex gap-[15px] pb-[22px]">
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      Fulltime
                    </button>
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      onsite
                    </button>
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      $200K
                    </button>
                  </div>
                  <h6 className="font-[700] font-sans text-[22px] text-[#263238] pb-[6px]">
                    Key Account Manager
                  </h6>
                  <p className="font-[400] font-sans capitalize text-[14px] text-[#263238] pb-[20px]">
                    advoit digital agency
                  </p>
                  <div className="flex justify-between items-center">
                    <button className="py-[14px] px-[26px] text-[#263238] rounded-[5px] bg-[#F1E60D] font-sans font-[400] text-[14px]">
                      Apply
                    </button>
                    <div className="flex items-center gap-[4px]">
                      <img src="/assets/media/people.svg" alt="" />
                      <p className="font-[400] font-sans capitalize text-[14px] text-[#263238]">
                        24 Applied
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-[#FFFFFF] rounded-[20px] border border-[#6953A3] py-[22px] px-[16px]">
                  <div className="flex gap-[15px] pb-[22px]">
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      Fulltime
                    </button>
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      onsite
                    </button>
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      $200K
                    </button>
                  </div>
                  <h6 className="font-[700] font-sans text-[22px] text-[#263238] pb-[6px]">
                    Key Account Manager
                  </h6>
                  <p className="font-[400] font-sans capitalize text-[14px] text-[#263238] pb-[20px]">
                    advoit digital agency
                  </p>
                  <div className="flex justify-between items-center">
                    <button className="py-[14px] px-[26px] text-[#263238] rounded-[5px] bg-[#F1E60D] font-sans font-[400] text-[14px]">
                      Apply
                    </button>
                    <div className="flex items-center gap-[4px]">
                      <img src="/assets/media/people.svg" alt="" />
                      <p className="font-[400] font-sans capitalize text-[14px] text-[#263238]">
                        24 Applied
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-[#FFFFFF] rounded-[20px] border border-[#6953A3] py-[22px] px-[16px]">
                  <div className="flex gap-[15px] pb-[22px]">
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      Fulltime
                    </button>
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      onsite
                    </button>
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      $200K
                    </button>
                  </div>
                  <h6 className="font-[700] font-sans text-[22px] text-[#263238] pb-[6px]">
                    Key Account Manager
                  </h6>
                  <p className="font-[400] font-sans capitalize text-[14px] text-[#263238] pb-[20px]">
                    advoit digital agency
                  </p>
                  <div className="flex justify-between items-center">
                    <button className="py-[14px] px-[26px] text-[#263238] rounded-[5px] bg-[#F1E60D] font-sans font-[400] text-[14px]">
                      Apply
                    </button>
                    <div className="flex items-center gap-[4px]">
                      <img src="/assets/media/people.svg" alt="" />
                      <p className="font-[400] font-sans capitalize text-[14px] text-[#263238]">
                        24 Applied
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-[#FFFFFF] rounded-[20px] border border-[#6953A3] py-[22px] px-[16px]">
                  <div className="flex gap-[15px] pb-[22px]">
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      Fulltime
                    </button>
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      onsite
                    </button>
                    <button className="bg-[#6953A3] rounded-[5px] py-[14px] px-[18px] font-[400] text-[14px] font-sans text-[#FFFFFF] capitalize">
                      $200K
                    </button>
                  </div>
                  <h6 className="font-[700] font-sans text-[22px] text-[#263238] pb-[6px]">
                    Key Account Manager
                  </h6>
                  <p className="font-[400] font-sans capitalize text-[14px] text-[#263238] pb-[20px]">
                    advoit digital agency
                  </p>
                  <div className="flex justify-between items-center">
                    <button className="py-[14px] px-[26px] text-[#263238] rounded-[5px] bg-[#F1E60D] font-sans font-[400] text-[14px]">
                      Apply
                    </button>
                    <div className="flex items-center gap-[4px]">
                      <img src="/assets/media/people.svg" alt="" />
                      <p className="font-[400] font-sans capitalize text-[14px] text-[#263238]">
                        24 Applied
                      </p>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="lg:pt-[90px] pb-[80px] pt-[44px] px-[32px] flex md:hidden justify-center">
          <img src="/assets/media/vector2.svg" alt="" />
        </div>
        <Footer2 />
      </div>
    </>
  );
}

export default OurWork;
